import type { BridgeRule, GeneratorCode, NeutralizationTheoremCode } from "@csk/core";

export interface WasmSquareFortification {
  readonly theoremCode: NeutralizationTheoremCode;
  readonly generatorCode: GeneratorCode;
}

export function generatorFromBridgeId(id: string): GeneratorCode | null {
  const prefix = id.split(".")[0];
  return prefix === "G1" || prefix === "G2" || prefix === "G3" || prefix === "G4" ? prefix : null;
}

export function allowedTransitionSquareContext(from: string, to: string): WasmSquareFortification {
  const target = generatorFromBridgeId(to);
  const source = generatorFromBridgeId(from);
  return {
    theoremCode: "I2",
    generatorCode: target === "G3" || source === "G3" ? "G3" : (target ?? source ?? "G1"),
  };
}

export function forbiddenTransitionSquareContext(rule: BridgeRule): WasmSquareFortification {
  const reason = (rule.reason ?? "").toLowerCase();
  if (reason.includes("epistemic") || reason.includes("classification") || reason.includes("g2")) {
    return { theoremCode: "S", generatorCode: "G2" };
  }
  if (
    reason.includes("phase") ||
    reason.includes("approval") ||
    reason.includes("retro") ||
    reason.includes("precede")
  ) {
    return { theoremCode: "W", generatorCode: "G3" };
  }
  return { theoremCode: "I2", generatorCode: "G3" };
}
